import { writable } from 'svelte/store';
import type { BtHomeRemoteIconStore } from 'src/types/BtHomeRemoteIcon';

const createBtHomeRemoteIconStore = () => {
	const { subscribe, update } = writable<BtHomeRemoteIconStore>({});

	return {
		subscribe,
		setState: (id: string, active: boolean) =>
			update((state) => ({
				...state,
				[id]: { active },
			})),
		clearState: (id: string) =>
			update((state) => {
				if (!(id in state)) return state;
				const next = { ...state };
				delete next[id];
				return next;
			}),
	};
};

export const btHomeRemoteIcon = createBtHomeRemoteIconStore();
